import { FC } from 'react';
import { ModalComponent } from 'components/Modal';
import Loader from 'components/Loader';

interface Props {
  isOpen: boolean;
  redirectPageName: string;
  redirectUrl?: string;
}

export const RedirectModal: FC<Props> = ({ isOpen, redirectPageName, redirectUrl }) => {
  return (
    <ModalComponent
      isOpen={isOpen}
      contentLabel="Redirect alert modal"
      style={{ maxWidth: '325px' }}
    >
      <div className="mb14">
        <div className="body-text">
          You will be redirected to {redirectPageName} automatically in a few seconds...
        </div>
        <div className="text-center full-width">
          <Loader width={60} height={60} />
        </div>
        {redirectUrl && (
          <>
            <div className="body-text mb6">
              If you are not redirected, please click the link below.
            </div>
            <a className="body-text" href={redirectUrl}>
              Go to {redirectPageName} manually
            </a>
          </>
        )}
      </div>
    </ModalComponent>
  );
};
